<template>
    <div>
        <b-media>
            <template #aside>
                <img :src="laImagen" width="70px" alt="Media Aside">
            </template>

            <div class="titulo">{{ fecha }}</div>
            <span class="titulo-pequenio">{{ titulo }}</span>
            <div class="text-right">
                <b-button @click="leerMas" variant="link" size="sm">Leer más</b-button>
            </div>

            <!-- b-[Optional: add media children here for nesting] -->
        </b-media>
        <hr>
    </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
    name: 'MiniNoticia',
    props: {
        idNoticia: String,
        fecha: String,
        titulo: String,
        imagen: String
    },
    data() {
        return {
            variable: ''
        }
    },
    methods: {
        leerMas() {
            try {
                this.$router.push(`/detallenoticia/${this.idNoticia}`)
            } catch (error) {
                if (!(error instanceof NavigationDuplicated)) {
                    throw error;
                }
            }
        }
    },
    computed: {
        laImagen() {
            if ( ["localhost", "127.0.0.1", ""].includes(window.location.hostname) ) {
                return `${this.urlSandbox}/imagenes/noticias/${this.imagen}`
            } else {
                return `${this.urlProd}/imagenes/noticias/${this.imagen}`
            }
            
        },
        ...mapState(['urlProd']),
        ...mapState(['urlSandbox'])
    }
}
</script>

<style scoped>
.titulo {
    font-size: 14px;
    font-weight: bold;
}
.titulo-pequenio {
    font-size: 11px;
}
</style>